import { GETRECRUITERUSERDETAILS } from "../ENVIRONMENT";

// api for recruiter details
async function recgetDetails(token) {
  const response = await fetch(GETRECRUITERUSERDETAILS, {
    headers: {
      "Content-Type": "Application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
  });
  return response;
}
export { recgetDetails };
